(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
function toggleElementBasedOnHash() {
    var elementToShow = document.getElementById("cancel-recover");
    if (window.location.hash === "#recover") {
        elementToShow.style.display = "flex";
    } else {
        elementToShow.style.display = "none"; 
    }
}

document.addEventListener("DOMContentLoaded", toggleElementBasedOnHash);

window.addEventListener("hashchange", toggleElementBasedOnHash);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function toggleContent(contentId) {
  var contentSection = document.getElementById(contentId).querySelector('.pq-tabs-content');
  if (contentSection) {
    contentSection.classList.toggle('expanded');
  }
};

document.querySelectorAll('.read-more-button').forEach(function(button) {
  button.addEventListener('click', function() {
    var contentId = this.getAttribute('data-content-id');
    toggleContent(contentId);
  });
});

var firstOptionText = document.querySelector('.dropdown-label').textContent;
document.querySelector('.custom-dropdown-trigger .trigger-text').textContent = firstOptionText;

document.querySelector('.custom-dropdown-trigger').addEventListener('click', function() {
  document.querySelector('.custom-dropdown-options').classList.toggle('show');
  var arrow = this.querySelector('.dropdown-arrow');
  if (arrow) {
    arrow.style.transform = arrow.style.transform === 'rotate(180deg)' ? 'rotate(0deg)' : 'rotate(180deg)';
  }
});

document.querySelectorAll('.custom-dropdown-option').forEach(function(label) {
  label.addEventListener('click', function() {
    var selectedTab = this.htmlFor.replace('custom-', ''); 
    document.querySelectorAll('.product-tabs-wrapper input[type="radio"]').forEach(function(radio) {
      radio.checked = false;
    });
    var targetRadio = document.getElementById(selectedTab);
    if (targetRadio) {
      targetRadio.checked = true;
      targetRadio.dispatchEvent(new Event('change'));
    }
    document.querySelector('.custom-dropdown-options').classList.remove('show');
    document.querySelector('.custom-dropdown-trigger .trigger-text').textContent = this.textContent;

    var arrow = document.querySelector('.custom-dropdown-trigger .dropdown-arrow');
    if (arrow) {
      arrow.style.transform = 'rotate(0deg)'; 
    }
  });
});

window.addEventListener('click', function(e) {
  if (!document.querySelector('.custom-dropdown').contains(e.target)) {
    document.querySelector('.custom-dropdown-options').classList.remove('show');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pq-slider"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  // Process title highlights
  document.querySelectorAll('.pq-slider-title').forEach(title => {
    const text = title.textContent.trim();
    const highlightColor = title.dataset.highlightColor;
    const defaultColor = title.dataset.defaultColor;
    const highlightStyle = title.dataset.highlightStyle || 'normal';
    
    // Replace {text} with <span class="highlight">text</span>
    const processedHtml = text.replace(/\{([^}]+)\}/g, (match, content) => {
      return `<span class="highlight ${highlightStyle}" style="color: ${highlightColor};">${content}</span>`;
    });
    
    title.innerHTML = processedHtml;
    title.style.color = defaultColor;
  });

  const classes = {
    slide: 'pq-slide',
    btnLeft: 'btn-left',
    btnRight: 'btn-right',
    dotsContainer: 'pq-slide-dots-container',
    dotsMobileContainer: 'pq-slide-dots-container-mobile',
    dotHtmlClass: 'pq-slide-dot',
    activeDotHtmlClass: 'pq-slide-dot-active',
  };

  const slides = document.querySelectorAll(`.${classes.slide}`);
  const btnLeft = document.querySelectorAll(`.btn-left`);
  const btnRight = document.querySelectorAll(`.btn-right`);
  const dotsContainer = document.querySelector(`.${classes.dotsContainer}`);
  const dotsMobileContainer = document.querySelector(`.${classes.dotsMobileContainer}`);
  

  const slidesCount = slides.length;
  let currentSlide = 0;
  let timerRef = null;
  const btnDirections = {
    left: 'left',
    right: 'right',
  };

  (() => {
    slides.forEach((slide, idx) => {
      slide.style.transform = `translateX(${100 * idx}%)`;
    });

    timerRef = setInterval(() => {
      moveSlideToRight();
    }, 6000);

    for (let i = 0; i < slidesCount; i++) {
      const dot = document.createElement('div');
      dot.dataset.slideNum = i;
      dot.classList.add(classes.dotHtmlClass);
      if (i === currentSlide) {
        dot.classList.add(classes.activeDotHtmlClass);
      }
      dotsContainer.appendChild(dot);
    
      const dotMobile = document.createElement('div');
      dotMobile.dataset.slideNum = i;
      dotMobile.classList.add(classes.dotHtmlClass);
      if (i === currentSlide) {
        dotMobile.classList.add(classes.activeDotHtmlClass);
      }
      dotsMobileContainer.appendChild(dotMobile);
    }
  })();

  const markDotAsActive = (slideNum) => {
    const desktopDots = dotsContainer.querySelectorAll(`.pq-slide-dot`);
    const mobileDots = dotsMobileContainer.querySelectorAll(`.pq-slide-dot`);

      const updateDots = (dots) => {
          dots.forEach((dot) => {
              dot.classList.remove(classes.activeDotHtmlClass);
  
              if (Number(dot.dataset.slideNum) === slideNum) {
                  dot.classList.add(classes.activeDotHtmlClass);
              }
          });
      };
  
      updateDots(desktopDots);
      updateDots(mobileDots);
  };

  const gotToSlide = (slideNum) => {
    slides.forEach((slide, idx) => {
      slide.style.transform = `translateX(${100 * (idx - slideNum)}%)`;
    });
    markDotAsActive(slideNum);
  };

  const moveSlideToRight = () => {
    if (currentSlide < slidesCount - 1) {
      currentSlide++;
    } else {
      currentSlide = 0;
    }
    gotToSlide(currentSlide);
  };

  const moveSlideToLeft = () => {
    if (currentSlide > 0) {
      currentSlide--;
    } else {
      currentSlide = slidesCount - 1;
    }
    gotToSlide(currentSlide);
  };

  const onButtonClick = (direction) => {
    return () => {
      if (timerRef) {
        clearInterval(timerRef);
      }
      if (direction === btnDirections.left) {
        moveSlideToLeft();
      } else {
        moveSlideToRight();
      }
    };
  };
  
  btnLeft.forEach(button => button.addEventListener('click', onButtonClick(btnDirections.left)));
  btnRight.forEach(button => button.addEventListener('click', onButtonClick(btnDirections.right)));
  
  let touchstartX = 0;
  let touchendX = 0;

  const slider = document.querySelector('.pq-slide-container');

  const handleSwipeGesture = () => {
    if (touchendX < touchstartX) moveSlideToRight();
    if (touchendX > touchstartX) moveSlideToLeft();
  };

  slider.addEventListener('touchstart', e => {
    touchstartX = e.changedTouches[0].screenX;
  });

  slider.addEventListener('touchend', e => {
    touchendX = e.changedTouches[0].screenX;
    handleSwipeGesture();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.pq-slide');

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const loadBackgroundImage = (entry) => {
    const slide = entry.target;
    const mobileImage = slide.getAttribute('data-bg-mobile');
    const desktopImage = slide.getAttribute('data-bg');

    if (entry.isIntersecting) {
      const imageUrl = window.innerWidth <= 749 ? mobileImage : desktopImage;
      slide.style.backgroundImage = `url('${imageUrl}')`;
      observer.unobserve(slide);
    }
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => loadBackgroundImage(entry));
  }, options);

  slides.forEach(slide => {
    observer.observe(slide);
  });
});

  } catch(e) { console.error(e); }
})();
})();
